module.exports = __webpack_public_path__ + "static/media/comp4.ffccf377.png";